import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "col-xs-12 col-sm-6 col-md-4" };
const _hoisted_2 = { class: "category-teaser__image" };
const _hoisted_3 = ["src", "alt"];
const _hoisted_4 = { class: "category-teaser__title" };
import { onMounted, ref } from 'vue';
import ProductUtils from "@astina/paloma-shop-common-ui/src/services/ProductUtils";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CategoryTeaser',
    props: {
        category: {}
    },
    setup(__props) {
        const props = __props;
        const image = ref(null);
        onMounted(() => {
            image.value = (props.category.image
                && ProductUtils.createImage(props.category.image)) || null;
        });
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_router_link, {
                    to: { name: 'catalog_category', params: { category: __props.category.code } },
                    class: "category-teaser"
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                            (image.value)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: image.value.url,
                                    alt: image.value.title
                                }, null, 8, _hoisted_3))
                                : _createCommentVNode("", true)
                        ]),
                        _cache[0] || (_cache[0] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("h4", null, _toDisplayString(__props.category.name), 1)
                        ])
                    ]),
                    _: 1
                }, 8, ["to"])
            ]));
        };
    }
});
